import _extends from "@babel/runtime-corejs3/helpers/extends";
import { useInstance } from 'intact-vue-next';
import { createContext } from '../context';
export var context = createContext();
export function useSortable() {
  var instance = useInstance();
  // if the same column has been clicked three times consecutively,
  // then let the third click to reset the sort
  var count = 0;
  function onChange(key, event) {
    // ignore when click group dropdown menu
    if (event._ignoreSortable) return;
    var sort = _extends({}, instance.get('sort'));
    if (sort.key === key) {
      count++;
      if (count === 3) {
        sort = {};
      } else {
        sort.type = sort.type === 'desc' ? 'asc' : 'desc';
      }
    } else {
      count = 1;
      sort.key = key;
      if (!sort.type) sort.type = 'desc';
    }
    instance.set('sort', sort);
  }
  return {
    onChange: onChange,
    ignoreSortable: ignoreSortable
  };
}
export function ignoreSortable(e) {
  e._ignoreSortable = true;
}